import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=7ca126e1"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=7ca126e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports